import React from 'react';

const SEGMENTS = [
  { key: '#fortnight', label: 'Fortnight' },
  { key: '#future', label: 'Future' },
  { key: '#recent', label: 'Paid' },
  { key: '#search', label: 'Search' },
];

const PhoneBillsSegments = ({ activeTab, setActiveTab }) => (
  <div className="phone-bills-segments" role="tablist" aria-label="Bills views">
    {SEGMENTS.map(({ key, label }) => (
      <button
        key={key}
        type="button"
        role="tab"
        aria-selected={activeTab === key}
        className={`phone-bills-segment ${activeTab === key ? 'phone-bills-segment--active' : ''}`}
        onClick={() => setActiveTab(key)}
      >
        {label}
      </button>
    ))}
  </div>
);

export default PhoneBillsSegments;
